import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import quartOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(quartOfYear);

export interface MainSliceType {
  settings: {
    gapIncomeType: "pre" | "cur";
  };
}
const initialState: MainSliceType = {
  settings: {
    gapIncomeType: "cur",
  },
};
export const AppSettingSlice = createSlice({
  name: "AppSettingSlice",
  initialState,
  reducers: {
    updateAppGapincomeType(state, action) {
      state.settings.gapIncomeType = action.payload;
    },
  },
});

const { actions, reducer } = AppSettingSlice;
export const { updateAppGapincomeType } = actions;
export default reducer;
